import React, { useEffect, useState } from 'react';

import axios from '../../services/MyAxios';

import Card from 'crm/elements/common/Card';

export default function LotteryGameTypes({ url }) {
    const [gameTypes, setGameTypes] = useState([]);
    useEffect(() => {
        axios.get(url).then((response) => {
            setGameTypes(response.data);
        });
    }, []);

    function getContent() {
        return (
            <Card title="Lottery Game Types">
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Name</th>
                                <th>Slug</th>
                                <th>Numbers to pick</th>
                                <th>Created at</th>
                                <th>Updated at</th>
                            </tr>
                        </thead>
                        <tbody>
                            {gameTypes.map((gameType, index) => (
                                <tr key={`game_type_no_${index + 1}`}>
                                    <td>{gameType.id}</td>
                                    <td>{gameType.name}</td>
                                    <td>{gameType.slug}</td>
                                    <td>{gameType.numbers_to_pick}</td>
                                    <td>{gameType.created_at}</td>
                                    <td>{gameType.updated_at}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Card>
        );
    }

    return gameTypes.length ? getContent() : null;
}
